import { Button, Form, Input, Modal, Space } from 'antd';
import React from 'react';

import type { EdutainmentCategory } from '../../types';
import styles from './index.module.scss';

type AddOrEditModalProps = {
  showModal: boolean;
  closeModal: () => void;
  editingCategory: EdutainmentCategory | undefined;
};

const { Item } = Form;

export const AddOrEditModal = ({
  showModal,
  closeModal,
  editingCategory,
}: AddOrEditModalProps) => {
  const onFormFinish = (formValues: EdutainmentCategory) => {
    console.log(formValues);
  };

  return (
    <Modal
      title={editingCategory ? '編輯育樂類別' : '新增育樂類別'}
      open={showModal}
      onCancel={closeModal}
      centered
      destroyOnClose
      maskClosable={false}
      footer={null}
    >
      <Form
        initialValues={editingCategory}
        layout="vertical"
        onFinish={onFormFinish}
      >
        <Item
          label="育樂類別"
          name="category"
          rules={[{ required: true, message: '請輸入育樂類別' }]}
        >
          <Input placeholder="例如：健康" />
        </Item>

        <Item label="類別介紹" name="description">
          <Input.TextArea
            placeholder="例如：講究技巧性的武藝、工藝。"
            maxLength={100}
            showCount
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Item>

        <Item className={styles.formActionButtons}>
          <Space>
            <Button htmlType="button" onClick={closeModal}>
              取消
            </Button>
            <Button htmlType="submit" type="primary">
              確定
            </Button>
          </Space>
        </Item>
      </Form>
    </Modal>
  );
};
